import React, { useContext as useContextCore, useMemo } from 'react'
import type { UseListResult, UseListWithSelection } from '@ztechapps/common.hook'
import { useListWithSelection } from '@ztechapps/common.hook'
import type { Project } from '@ztechapps/common.contract'
import { useProjectList } from '@ztechapps/project.common'

export type ProjectListContextProps = {
  filterCategory?: string
  children: React.ReactNode
}
export type ProjectListProps = Omit<ProjectListContextProps, 'children'>

export type ProjectListContextType = {
  filterCategory: string
  selectedProjectIds: string[]
  selectedProjects: Project[]
  projectList: UseListResult<Project>
  projectListWithSelection: UseListWithSelection<Project>
} & ProjectListProps

const context = React.createContext({} as ProjectListContextType)
const CoreProvider = context.Provider
const defaultFilterCategory = 'projectFilterCategory'

export const ProjectListProvider = ({ children, filterCategory, ...rest }: ProjectListContextProps) => {
  //set the default filterCategory
  filterCategory = filterCategory ?? defaultFilterCategory

  const projectList = useProjectList({ listActionOptions: { storageKey: filterCategory }, subscribeToUpdates: true })
  const projectListWithSelection = useListWithSelection(projectList?.list)
  const selectedProjectIds = useMemo(() => {
    return projectListWithSelection.selectedList.map((item) => item._id)
  }, [projectListWithSelection])
  const selectedProjects = projectListWithSelection.selectedList

  return (
    <CoreProvider
      value={{
        ...rest,
        projectList,
        projectListWithSelection,
        filterCategory,
        selectedProjects,
        selectedProjectIds,
      }}
    >
      {children}
    </CoreProvider>
  )
}

export const useProjectListContext = () => useContextCore(context)
